import React, { useEffect } from 'react'
import Loader from '../../components/Loader';

const ItemList = ({ all, selected, setSelected, data, title, disabled, allDisabled, setAll, loading, setMore, selectedKey }) => {
    useEffect(() => {
        if (all && all == true) {
            setSelected([]);
            if (setMore) setMore(undefined)
        }
    }, [])

    const handleAllChange = () => {
        if (allDisabled || disabled) return;
        const newAll = !all;
        setAll(newAll);
        if (newAll && setMore) {
            setMore(undefined);
        }
    };

    const handleItemChange = (item) => {
        if (disabled) return;

        const isSelected = selected?.find((select) => select?._id == item?._id);

        if (all) {
            setSelected((data || []).filter((entry) => entry._id != item._id));
            if (setMore) setMore(undefined);
            return;
        }

        if (isSelected) {
            setSelected(selected?.filter((select) => select?._id != item._id));
            if (setMore) setMore(undefined);
        } else {
            setSelected([...(selected || []), item]);
            if (setMore) setMore(item);
        }
    };

    return (
        <div style={{ flex: 1 }}>
            <h5>{title}</h5>
            <div className="form-check" >
                <input className="form-check-input" type="checkbox" checked={all} onChange={handleAllChange} disabled={allDisabled || disabled} />
                <label className="form-check-label" >
                    All
                </label>
            </div>
            <Loader loading={loading}>
                {
                    data?.map((item, index) => {
                        const id = `${item._id}${index}`;
                        const isSelected = selected?.find((select) => select?._id == item?._id);
                        return (
                            <div className="form-check d-flex gap-2" key={index}>
                                <input
                                    className="form-check-input"
                                    checked={!!isSelected || all}
                                    type="checkbox"
                                    value=""
                                    id={id}
                                    disabled={disabled}
                                    onChange={() => handleItemChange(item)}
                                />
                                <label className="form-check-label" htmlFor={id}>
                                    {item.name}
                                </label>


                                {!setMore || (!isSelected && !all) ? null :
                                    <span
                                        className='text-primary'
                                        onClick={() => setMore(item)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <i className="bi bi-chevron-double-right"></i>
                                    </span>
                                }
                            </div>
                        )
                    })
                }
                {
                    data?.length == 0 || !data ? <span className='text-secondary'>No items</span> : null
                }
            </Loader>
        </div>
    )
}

export default ItemList